module.exports = __webpack_public_path__ + "img/loading-panoramic.29ce10d5.svg";